import React from 'react';

export default function ReturnsPolicy() {
  return (
    <div className="bg-[#FAF8F5] min-h-screen text-[#2B1810] py-12">
      <div className="max-w-4xl mx-auto px-4 space-y-8 bg-white p-8 md:p-12 rounded-2xl border border-[#E8DFD8] shadow-sm">
        <div className="text-center space-y-2 border-b border-[#E8DFD8] pb-6">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#C49A45]">Hassle-Free Returns</span>
          <h1 className="font-heading text-3xl font-bold text-[#2B1810]">Return & Refund Policy</h1>
          <p className="text-xs text-[#8A796C]">7-Day Easy Return & Replacement Guarantee</p>
        </div>

        <div className="space-y-6 text-xs leading-relaxed text-[#2B1810]">
          <section className="space-y-2">
            <h2 className="font-heading text-base font-bold text-[#2B1810]">1. 7-Day Return Window</h2>
            <p className="text-[#8A796C]">
              We offer a hassle-free 7-day return and replacement policy from the date of delivery. If you receive a damaged, defective, or incorrect sandalwood artifact, we will arrange a free reverse pickup and dispatch a replacement.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="font-heading text-base font-bold text-[#2B1810]">2. Eligibility Conditions</h2>
            <ul className="list-disc pl-5 space-y-1 text-[#8A796C]">
              <li>Items must be unused and in their original rigid kraft box packaging.</li>
              <li>The authenticity certificate card and velvet pouch must be included.</li>
              <li>Custom engraved or personalized idols are eligible for replacement only in case of transit damage.</li>
            </ul>
          </section>

          <section className="space-y-2">
            <h2 className="font-heading text-base font-bold text-[#2B1810]">3. Refund Process</h2>
            <p className="text-[#8A796C]">
              Once the returned product passes quality inspection at our Mysuru warehouse, refunds are processed within 3-5 business days back to your original payment method or bank account.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
